import { semanticOrder as e } from "./toolbar-semantic-order.mjs";
import { Fragment as t } from "react";
import { twJoin as n } from "tailwind-merge";
import { jsx as r } from "react/jsx-runtime";
//#region src/toolbar/render-semantic-order.tsx
var i = ({ extension: e, source: i, skipRef: a, withRightBorder: o, inSheet: s }) => {
	let c = i.filter((t) => t.key === e);
	return c.length ? c.map((e, i) => s ? /* @__PURE__ */ r(t, { children: e.toolbarItem.sheetRender }, e.id) : /* @__PURE__ */ r("div", {
		ref: a ? void 0 : e.ref,
		className: n(i === c.length - 1 && o && "border-border-100 border-r last-of-type:border-r-0", "flex items-center", "px-px first-of-type:pl-0 last-of-type:pr-0"),
		children: e.toolbarItem.toolbarRender
	}, e.id)) : null;
}, a = ({ source: t, skipRef: n, inSheet: r }) => e.flatMap((a, o) => {
	let s = o === e.length - 1;
	return Array.isArray(a) ? a.flatMap((e, o) => i({
		extension: e,
		source: t,
		skipRef: n,
		withRightBorder: !s && o === a.length - 1,
		inSheet: r
	})) : i({
		extension: a,
		source: t,
		skipRef: n,
		withRightBorder: !s,
		inSheet: r
	});
});
//#endregion
export { a as renderInSemanticOrder };
